import EasyGithubPages from './EasyGithubPages'

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component(EasyGithubPages.name, EasyGithubPages)
}

export default EasyGithubPages
